import React, { memo, Fragment, Suspense, useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import Headerpro from "../../../../../../components/partials/pro/headerstyle/header-pro";
import ChannelSidebar from "../components/partials/channel-sidebar";
import Footer from "../../../../../../components/partials/dashboard/footerstyle/footer";
import * as SettingSelector from "../../../../../../store/setting/selectors";
import { useDispatch, useSelector } from "react-redux";
import "../../../../../../assets/modules/e-commerce/scss/e-commerce.scss";
import { setCurrentChannel } from "../../../../../../store/channel/channel.action";
import { useGetChannelDetails } from "../../../../../../queries/query-hooks/workspace/workspace-hook";
import PageNotFound from "../../../../../PageNotFound";
import useRedirect from "../../../../../../components/custom-hooks/use-redirect";

const ChannelLayout = memo(() => {
  const pageLayout = useSelector(SettingSelector.page_layout);
  const params = useParams();
  const { redirectTo } = useRedirect();
  const dispatch = useDispatch();
  const [isValidChannelId, setIsValidChannelId] = useState(true);
  const { data: channelDetailsData, isLoading: isDetailsLoading } =
    useGetChannelDetails(params.channel_id);

  useEffect(() => {
    if (params.channel_id) {
      dispatch(setCurrentChannel({ channel_id: params.channel_id }));
    }
  }, []);

  useEffect(() => {
    if (channelDetailsData?.length < 1) {
      setIsValidChannelId(false);
    }
  }, [channelDetailsData]);

  const fallBackHandler = () => {
    redirectTo("project/channels");
  };

  return (
    <Fragment>
      <ChannelSidebar />
      <main className="main-content">
        <div className="position-relative">
          <Headerpro />
        </div>
        {!isValidChannelId && !isDetailsLoading ? (
          <PageNotFound
            title="You are not authorized to view this content"
            buttonText="Home"
            onFallbackClick={fallBackHandler}
          />
        ) : (
          <div
            className={`container-fluid content-inner pb-0 ${pageLayout}`}
            id="page_layout"
          >
            <Suspense fallback={<div className="react-load"></div>}>
              <Outlet />
            </Suspense>
          </div>
        )}
        <Footer />
      </main>
    </Fragment>
  );
});

ChannelLayout.displayName = "ChannelLayout";
export default ChannelLayout;
